
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30.002","height":"30.002","rx":"15.001","fill":"#E2E2E2"}}),_c('g',{attrs:{"fill":"#D45454"}},[_c('path',{attrs:{"d":"M17.064 24.376h-4.232c-2.207 0-4-1.765-4-3.938V9.33h12.232v11.102c0 2.173-1.793 3.938-4 3.938v.006zm-7.32-3.938c0 1.676 1.386 3.04 3.088 3.04h4.232c1.702 0 3.088-1.364 3.088-3.04v-10.21H9.745v10.21z"}}),_c('path',{attrs:{"d":"M20.937 10.24c-.049 0-.104 0-.152-.007H9.075c-.42 0-.815-.161-1.113-.448A1.527 1.527 0 017.5 8.689c0-.85.705-1.544 1.569-1.544h12.008c.87.09 1.501.844 1.416 1.694a1.56 1.56 0 01-1.563 1.4h.007zM9.069 8.043a.649.649 0 00-.657.646.658.658 0 00.663.652h11.759a.721.721 0 00.528-.143.67.67 0 00.238-.437.654.654 0 00-.596-.712H9.074l-.005-.006z"}}),_c('path',{attrs:{"d":"M17.696 8.037h-5.502l-.116-.281a1.594 1.594 0 01-.115-.58c0-.85.705-1.545 1.568-1.551h2.815c.87 0 1.575.694 1.575 1.55 0 .198-.036.395-.11.58l-.115.282zm-4.815-.898h4.128a.66.66 0 00-.657-.616h-2.815a.66.66 0 00-.656.616zM12.2 21.372a.456.456 0 01-.456-.45v-8.84a.456.456 0 01.912 0v8.84a.456.456 0 01-.456.45zM14.948 21.372a.456.456 0 01-.456-.45v-8.84a.456.456 0 01.912 0v8.84a.456.456 0 01-.456.45zM17.696 21.372a.456.456 0 01-.456-.45v-8.84a.456.456 0 01.912 0v8.84a.456.456 0 01-.456.45z"}})])])
          )
        }
      }
    